import clsx from 'clsx';

interface PingProps {
	className?: string;
	animate?: boolean;
	dimensions?: `w-${string} h-${string}`;
	colour?: `bg-${string}`;
	dotClassName?: string;
	pingClassName?: string;
}

export function Ping({ className, animate = true, dimensions = 'w-3 h-3', dotClassName, colour = 'bg-blue', pingClassName }: PingProps) {
	return (
		<span className={clsx('relative flex', dimensions, className)}>
			<span
				className={clsx(
					'absolute inline-flex h-full w-full rounded-full opacity-75',
					animate && 'animate-ping',
					colour,
					pingClassName,
				)}
			/>
			<span className={clsx('relative inline-flex rounded-full', colour, dimensions, dotClassName)} />
		</span>
	);
}
